// removed by extract-text-webpack-plugin
module.exports = {"status-ok":"device-status-text-status-ok--2QrT4","status-warning":"device-status-text-status-warning--3L7X8","status-disconnected":"device-status-text-status-disconnected--3p-G8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeviceStatusText/device-status-text.scss
// module id = NX5i
// module chunks = 4